// AppleCardsCarouselDemo.js
"use client";

import React from "react";
import { Carousel, Card } from "../@/components/ui/apple-cards-carousel";
import member1 from "../../img/adminTetam/member1.png";
import member2 from "../../img/adminTetam/member2.jpg";
import member3 from "../../img/adminTetam/member3.jpeg";
import member4 from "../../img/adminTetam/member4.jpeg";
import member5 from "../../img/adminTetam/member5.jpeg";
import member6 from "../../img/adminTetam/member6.jpeg";
import member7 from "../../img/adminTetam/member7.jpeg";
import member8 from "../../img/adminTetam/member8.jpeg";
import member9 from "../../img/adminTetam/member9.jpeg";
import member10 from "../../img/adminTetam/member10.jpeg";
import member11 from "../../img/adminTetam/member11.jpeg";
import member12 from "../../img/adminTetam/member12.jpeg";
import member13 from "../../img/adminTetam/member13.jpeg";
import member14 from "../../img/adminTetam/member14.jpeg";
import member15 from "../../img/adminTetam/member15.jpeg";
import member16 from "../../img/adminTetam/member16.jpeg";
import member17 from "../../img/adminTetam/member17.jpeg";
import member18 from "../../img/adminTetam/member18.jpeg";
import member19 from "../../img/adminTetam/member19.jpeg";

const Image = ({ src, alt, height, width, className }) => (
  <img src={src} alt={alt} height={height} width={width} className={className} />
);

export function AppleCardsCarouselDemo() {
  const cards = data.map((card, index) => (
    <Card key={card.src} card={card} index={index} />
  ));

  return (
    <div className="w-full h-full py-10">
      <h2 className="max-w-7xl pl-4 mx-auto text-xl md:text-3xl text-neutral-200 font-varelaround">
        Get to know our Admins.
      </h2>
      <Carousel items={cards} />
    </div>
  );
}



const data = [
  {
    category: "Club Advisor",
    title: "Aashrytha",
    src: member1,
  },
  {
    category: "Club Advisor",
    title: "Anudeep",
    src: member2,
  },
  {
    category: "President",
    title: "Sai Chandra Kande",
    src: member3,
  },
  {
    category: "Vice President",
    title: "Lohit Apuroop",
    src: member4,
  },
  {
    category: "Vice President",
    title: "Mitta Abhinay",
    src: member5,
  },
  {
    category: "Secretary",
    title: "M.K Harini",
    src: member6,
  },
  {
    category: "Secretary",
    title: "Ankit Kumar",
    src: member7,
  },
  {
    category: "Human Relations Incharge",
    title: "Lohitha Koneru",
    src: member8,
  },
  {
    category: "Technical Co-ordinator",
    title: "Ahana Chatterjee",
    src: member9,
  },
  {
    category: "Communication Incharge",
    title: "Saraswathula Koushik",
    src: member10,
  },
  {
    category: "Community Manager",
    title: "Kowshik Marlapati",
    src: member11,
  },
  {
    category: "Community Manager",
    title: "Aasrith Mamidi",
    src: member12,
  },
  {
    category: "Community Manager",
    title: "Srujana Gayathri",
    src: member13,
  },
  {
    category: "Community Manager",
    title: "Rohith Vishnu Kumar",
    src: member14,
  },
  {
    category: "Community Manager",
    title: "Hasini Royal",
    src: member15,
  },
  {
    category: "Community Manager",
    title: "Jenvitha Desari",
    src: member16,
  },
  {
    category: "Community Manager",
    title: "Thanush Chowdary",
    src: member17,
  },
  {
    category: "Community Manager",
    title: "SAI SAMEER KUMAR",
    src: member18,
  },
  {
    category: "Community Manager",
    title: "Megha syam",
    src: member19,
  },
];
